import { IRoute } from "../../../common/helpers/routesMapper";
import image from "./image";
import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";

export default {
    component: lazyComponent,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({
            title: allMessage["article.experience.title"],
            description: allMessage["article.experience.description"],
            allMessage,
            lang,
            image,
        });
    },
} satisfies IRoute;
